import URL from '@/api/URL'
import fetch from '@/api/fetch'

export function queryCallLogList(params) {
    return fetch.post(URL.callLogList, params);
}

export function querySaasAppealList(params) {
    return fetch.post(URL.saasAppealList, params);
}

export function saasGetAppealInfoByLogId(params) {
    return fetch.post(URL.saasGetAppealInfoByLogId, params);
}

export function getCallLogDetail(params) {
    return fetch.post(URL.callLogDetail, params)
}

export function callLogFileDownload(params) {
    return fetch.post(URL.callLogFileDownload, params)
}

export function examineAppealLog(params) {
    return fetch.post(URL.examineAppealLog, params)
}

export function saasGetAppealInfo(params) {
    return fetch.post(URL.saasGetAppealInfo, params)
}

export function getCloudApiList(params) {
    return fetch.post(URL.getCloudApiList, params)
}

export function getCloudApiInfo(params) {
    return fetch.post(URL.getCloudApiInfo, params)
}

export function examineCloudApi(params) {
    return fetch.post(URL.examineCloudApi, params)
}
export function getCallStatisticsChartData(params) {
    return fetch.post(URL.getCallStatisticsChartData, params)
}
export function LogCheckData(params) {
    return fetch.post(URL.LogCheckData, params)
}
export function searchProxyInfoPage(params) {
    return fetch.post(URL.searchProxyInfoPage, params)
}
export function searchMqttInfoPage(params) {
    return fetch.post(URL.searchMqttInfoPage, params)
}


// WEBPACK FOOTER //
// ./src/api/modules/cloudInterface.js